import { OrderStatus, ResourceFilterType, RetailUserAddressType, UserAccountStatus, UserCartStatus, UserType } from './techpubs-cms';

export function orderStatusOptions(): string[] {
  return Object.keys(OrderStatus);
}

export function cartStatusOptions(): string[] {
  return Object.keys(UserCartStatus);
}

export function accountStatusOptions(): string[] {
  return Object.keys(UserAccountStatus);
}

export function userTypeOptions(): string[] {
  return Object.keys(UserType);
}

export function retailUserAddressTypeOptions(): string[] {
  return Object.keys(RetailUserAddressType);
}

export function resourceFilterTypes(): string[] {
  return Object.keys(ResourceFilterType);
}
